import Button from '@gef-ui/components/atoms/Button';
import { Grid, GridAlignTypes, GridCol, GridDisplaySizes } from '@gef-ui/components/organisms/Grid';
import { getLabelMessage } from '@gef-ui/localization/messages';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'CenteredButton';
const CenteredButton = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { label, onClick, disabled } = props;
    return /*#__PURE__*/ React.createElement(Grid, {
        alignmentsForDisplays: [
            {
                [GridDisplaySizes.XS]: GridAlignTypes.CENTER
            }
        ]
    }, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 10,
        sizeSM: 5
    }, /*#__PURE__*/ React.createElement(Button, {
        primary: true,
        block: true,
        disabled: disabled,
        onClick: onClick,
        label: getLabelMessage(label)
    })));
};
CenteredButton.propTypes = {
    company: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func
};
export default CenteredButton;
